import { ReactNode } from 'react';
const SmoothLoader: React.FC<{ loading: boolean; children: ReactNode }> = ({ loading, children }) => (
  <div style={{ opacity: loading ? 0.1 : 1, transition: loading ? '0.2s all' : '1.2s all' }}>{children}</div>
);
export default SmoothLoader;
